var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755419566037,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16613,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M834.08 235.31c33.39-62.01-4.77-143.13-4.77-143.13-85.86 0-147.9 57.24-147.9 57.24-33.39-19.08-143.13-19.08-143.13-19.08s-109.74 0-143.13 19.08c0 0-62.01-57.24-147.9-57.24 0 0-38.16 81.09-4.77 143.13 0 0-76.32 71.55-47.7 224.22 26.91 143.46 152.67 181.29 233.76 181.29 0 0-33.39 28.62-28.62 76.32 0 0-47.7 28.62-95.4 9.54s-71.55-66.78-71.55-66.78-47.7-62.01-95.4-38.16c0 0-14.31 14.31 38.16 38.16 0 0 38.16 57.24 52.47 90.63s90.63 62.01 166.98 42.93v109.71s0 9.54-19.08 14.31-19.08 14.31-9.54 14.31h343.5c9.54 0 9.54-9.54-9.54-14.31s-19.08-14.31-19.08-14.31V793.46s0.42-57.21 0-76.32c-1.05-47.94-33.39-76.32-33.39-76.32 81.09 0 206.85-37.83 233.76-181.29 28.62-152.67-47.7-224.22-47.7-224.22z",
    "p-id": 16614
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d99d8f0bcd60ad775e6ab91d9c3f9797.svg";
export { ForwardRef as ReactComponent };